/** @format */

import jMoment from 'moment-jalaali';
import persianJs from 'persianjs';
import { saveAs } from 'file-saver';
import { api } from 'utility';
import queryString from 'query-string';
import moment from 'moment';
import _ from 'lodash';
import createToast from 'components/Toast/Toast';
import DOMPurify from 'dompurify';
import * as Sentry from '@sentry/react';
import { actionPages, reportPagesKey } from 'utility'


export function getLS(key) {
  const val = localStorage.getItem(key) || '';
  return ['undefined', 'null', 'NaN'].indexOf(val) > -1 ? '' : val;
}

export function displayErrMsg() {
  return (error) => createToast('خطا', 'درخواست با خطا مواجه شد', 'danger');
}
export function removeKeyObjects(obj, keys) {
  if (!obj) return {};
  const res = { ...obj };
  for (const k of keys) {
    if (res.hasOwnProperty(k)) {
      delete res[k];
    }
  }
  return res;
}

export const isEqualInCommonKeys = (obj1, obj2) => {
  const commonKeys = _.intersection(Object.keys(obj1), Object.keys(obj2));
  for (const k in commonKeys) if (obj1[commonKeys[k]] !== obj2[commonKeys[k]]) return false;

  return true;
};
export function parseToJSON(jsonString, defaultValue) {
  try {
    return JSON.parse(jsonString || JSON.stringify(defaultValue));
  } catch (error) {
    return defaultValue;
  }
}
export function deleteNullValueFromObj(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === null || obj[key] === '') {
      delete obj[key];
    }
  });
}
export function numberWithCommas(x) {
  if (x === null || x === undefined) return x;
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export function getUrlParameter(name) {
  // name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function checkKeyInObject(obj, params) {
  if (!Array.isArray(params)) {
    return params in obj;
  }

  return params.some((item) => item in obj);
}

export function jDateNow(obj) {
  const format = obj?.format || 'jYYYY/jMM/jDD';
  const dateNow = jMoment(new Date());
  return dateNow.format(format);
}

export function jDateNMonthAgo(n, obj) {
  const format = obj?.format || 'jYYYY/jMM/jDD';
  const dateNow = jMoment(new Date());
  return dateNow.subtract(n, 'jMonth').format(format);
}

export function jDateNDaysAgo(n, obj) {
  const format = obj?.format || 'jYYYY/jMM/jDD';
  const dateNow = moment(new Date());
  dateNow.subtract(n, 'day');
  jMoment(new Date());
  return dateNow.subtract(n, 'day').format(format);
}

export function standardTimeStamp(time) {
  time = time.toString();
  if (time.length === 10) {
    return time;
  }

  return time.substr(0, 10);
}
/**
 * تعداد کارکتری که میخوایم از رشته نمایش بدیم و در پایان رشته سه نقطه قرار میگیرد
 */
export function stringLimitShow(str, numberChar = 20) {
  if (!str) {
    return '';
  }
  if (String(str).length > numberChar) {
    return String(str).substring(0, numberChar) + ' ...';
  }
  return str;
}

export function enifyDateTime(dt) {
  const dstr = `${dt}`;
  return persianJs(dstr).toEnglishNumber().toString();
}

export function enifyNumber(dt) {
  const targetString = `${dt}`;
  return persianJs(targetString).toEnglishNumber().toString();
}

export const numberTester = new RegExp(/^[0-9]+$/); // regexp to test whether the text is number or not

export function getQuery(location) {
  return queryString.parse(location.search);
}

export function serialize(obj, prefix) {
  const str = [];
  let p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      const k = prefix ? `${prefix}[${p}]` : p;
      const v = obj[p];
      str.push(
        v !== null && typeof v === 'object' ? serialize(v, k) : `${encodeURI(k)}=${encodeURI(v)}`,
      );
    }
  }
  return str.join('&');
}

export async function fileDownloader(
  method,
  url,
  params,
  data,
  filename,
  extension = 'txt',
  onDone,
  onError,
) {
  const tempParams = params;
  if (tempParams.hasOwnProperty('page')) {
    delete tempParams.page;
  }
  if (tempParams.hasOwnProperty('size')) {
    delete tempParams.size;
  }

  return api
    .post(url, data, { responseType: 'blob', params: { ...tempParams } })
    .then((res) => {
      res.data.text().then((d) => {
        if (d.includes('"status":500')) {
          const resObj = JSON.parse(d);
          if (onError) onError(resObj?.message?.split?.('.')?.[0]);
        } else {
          let ext = extension;
          let ctype =
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
          switch (extension) {
            case 'xls':
              ext = 'xlsx';
              ctype =
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
              break;
            case 'xlsx':
              ext = 'xlsx';
              ctype =
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
              break;
            default:
              break;
          }
          if (extension === 'csv') {
            const reader = new FileReader();
            reader.readAsText(
              new Blob([res.data], {
                type: ctype,
              }),
            );
            reader.onloadend = function () {
              const csvString = reader.result;
              const universalBOM = '\uFEFF';
              const a = window.document.createElement('a');
              a.setAttribute(
                'href',
                `data:text/csv; charset=utf-8,${encodeURIComponent(universalBOM + csvString)}`,
              );
              a.setAttribute(
                'download',
                `${`report-${enifyDateTime(jDateNow({ format: 'jYYYY/jMM/jDD' }))}`}.csv`,
              );
              window.document.body.appendChild(a);
              a.click();
            };
          } else
            saveAs(
              new Blob([res.data], {
                type: ctype,
              }),
              filename ??
              `${`report-${enifyDateTime(jDateNow({ format: 'jYYYY/jMM/jDD' }))}.`}${ext}`,
            );
        }
      });
    })
    .then(() => {
      if (onDone) onDone();
    });
}

export function makeCSVFromObject(titles = [], data = [], fileName = 'export-items') {
  // make titles of csv
  let csv = '';
  titles.forEach((v, k) => {
    csv += `${k !== 0 ? ', ' : ''}${v}`;
  });
  csv += '\n';

  // append data rows of csv
  data.forEach((v) => {
    Object.keys(v).forEach((key, j) => {
      csv += `${j !== 0 ? ', ' : ''}${v[key] ?? ''}`;
    });
    csv += '\n';
  });

  // download it
  const universalBOM = '\uFEFF';
  const hiddenElement = document.createElement('a');
  hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(universalBOM + csv)}`;
  hiddenElement.target = '_blank';
  hiddenElement.download = `${fileName}.csv`;
  hiddenElement.click();
}

// Methods to encode url
export function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }

  let serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    const parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key += '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(`${encode(key)}=${encode(v)}`);
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

function encode(val) {
  return encodeURIComponent(val)
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']');
}

function isObject(val) {
  return val !== null && typeof val === 'object';
}

function isDate(val) {
  return toString.call(val) === '[object Date]';
}

function isArray(val) {
  return toString.call(val) === '[object Array]';
}

function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /* eslint no-param-reassign:0 */
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (let i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

export const sleep = (ms = 3000) => new Promise((resolve) => setTimeout(resolve, ms));

const utils = {
  forEach,
  isURLSearchParams,
  isDate,
  isObject,
  isArray,
};
// End

export const getCaptcha = () => {
  const url = `/captchaCore`;
  return api.get(url).then((res) => res.data);
};
export const getCaptcha2 = () => {
  const url = `/captcha`;
  return api.get(url).then((res) => res.data);
};

export const isSandbox = () => {
  return window?.origin?.indexOf('sandbox') > -1;
};

export const getEnvironment = () => {
  const env = process.env.REACT_APP_ENVIRONMENT;
  if (env === 'development') return env;

  if (isSandbox()) return 'sandbox';

  return 'production';
};

/**
 * از طریق کتابخونه سنیتایزر، دام  صفحه رو بصورت امن ایجاد میکنیم
 */
export const createSanitizeHtml = (html) => {
  return DOMPurify.sanitize(html, { FORCE_BODY: true });
};

export const createSanitizeCustom = (html, attr) => {
  return DOMPurify.sanitize(html, attr);
};


/**
 * ایجاد شی سنتری برای اتصال و ارسال لاگ
 */
export const initialSentry = (businessData) => {
  const env = process.env?.REACT_APP_ENVIRONMENT;
  const sentry = process.env?.REACT_APP_SENTRY;
  Sentry.init({
    //release:'mytest _' + env,
    dsn: sentry,
    environment: env,
    autoSessionTracking: true,
    integrations: [new Sentry.BrowserTracing()],
    initialScope: (scope) => {
      scope.setUser({ id: businessData?.id });
    },
    tracesSampleRate: 1.0,
  });
};
let actionResult = [];
const getActionList = () => {
  return actionResult;
};

export const checkActionPage = async (actionList) => {
  actionResult = actionList;
  return await actionList;
};
let reportPagesResult = [];
export const checkReportPages = async (reportPages) => {
  if (!reportPages) return;
  reportPagesResult = reportPages;
  return await reportPagesResult;
};
const getReportPageList = () => {
  let list = reportPagesResult.map(a => a.key);
  return list;
};

export const computeAction = (key) => {
  return getActionList().includes(key);
};
export const computeReportPages = (key) => {
  return getReportPageList().includes(key);
};

export const getDynamicReportPages = (arrayList = []) => {
  let obj = {}
  for (let item of arrayList) {
    obj[item] = getReportPageList().includes(reportPagesKey()[item]) ? true : false;
  }
  //obj[key] = getReportPageList().includes(reportPagesKey()[key]) ? true : false;
  return obj
};
/**
 * آرایه از رشته اکشن ها میگیرد و بررسی میکند دسترسی دارد یا خیر که آبجکتی با همان رشته ها برمیگرداند.
 * عناوین ارسالی بسیار مهم هستند و باید با عنوان اکشن های ما برابر باشند
 */
export const getDynamicObjectAction = (arrayList = []) => {
  let obj = {}
  for (let item of arrayList) {
    obj[item] = getActionList().includes(actionPages()[item]) ? true : false;
  }
  return obj
};


export const sendErrorToSentry = (businessData, e) => {
  if (businessData) {
    Sentry.configureScope((scope) => {
      //scope.setUser({ username: businessData?.username, id: businessData?.id });
      scope.setContext('error_response', e?.response?.data);
      scope.setLevel('error');
      scope.setTag('error_tag');
      return Sentry.captureException(
        new Error(`خطای ${e?.response?.status} سرویس ${e?.config?.url}`),
      );
    });
  }
};


export const formatPrice = (
  amount,
  {
    defaultValue = '-',
    currency = '',
    showCurrency = true,
  } = {}
) => {
  // بررسی مقادیر خالی
  if (amount === null || amount === undefined || amount === '') {
    return defaultValue;
  }

  // حذف کاماهای احتمالی
  const cleanStr = amount.toString().replace(/,/g, '');
  const num = parseFloat(cleanStr);

  if (isNaN(num)) return defaultValue;

  // جدا کردن بخش صحیح و اعشار
  const [integerPart, decimalPart] = num.toString().split('.');

  // فرمت کردن بخش صحیح
  const formattedInteger = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ','
  );

  const formattedNumber = decimalPart
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;

  return showCurrency && currency
    ? `${formattedNumber} ${currency}`
    : formattedNumber;
};
